import React, { useState, useRef } from 'react';
import { showErrorToast, showSuccessToast } from '../../utils/toastUtils';
import { verifyaADHAROtpSignUP } from '../../Services/profile/profileservice';

const PinInput = ({ inputRefs, onPinChange,onSubmit }) => {
  const [pin, setPin] = useState(['', '', '', '', '', '']);

  const handleChange = (index, value) => {
    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

 const fullPin = newPin.join('');
    if (onPinChange) onPinChange(fullPin);

    // Move focus to next input
    if (value !== '' && index < 5) inputRefs.current[index + 1].current.focus();

    // Auto-submit when 6 digits are entered
    if (fullPin.length === 6 && onSubmit) {
      onSubmit(fullPin); // pass fullPin directly
    }
  };

  const handleBackspace = (index, event) => {
    if (event.key === 'Backspace' && index > 0 && pin[index] === '') {
      inputRefs.current[index - 1].current.focus();
    }
  };


  return (
    <div className="flex justify-center mb-4">
      {pin.map((value, index) => (
        <React.Fragment key={index}>
          <input
            ref={inputRefs.current[index]}
            type="password"
            maxLength={1}
            value={value}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleBackspace(index, e)}
            className="border border-blue-500 md:w-10 md:h-10 w-9 h-10 text-center mx-1 rounded shadow-lg shadow-blue-600"
            autoFocus={index === 0}
          />
          {index === 2 && <span className="mt-2 text-sky-500 ml-1">&ndash;</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

const DigitalKycAadharSignUp = ({ isModalOpen, toggleModal, title, clientID,onLoadReport,setSignatoryData }) => {
  const inputRefs = useRef(Array.from({ length: 6 }).map(() => React.createRef()));
    const [otp, setOtp] = useState('');
  const [error, setError] = useState('');

 
const handleSubmit = async (currentOtp = otp) => {
    if (currentOtp.length !== 6) {
      setError('Please enter a 6-digit OTP.');
      return;
    }

   if (!clientID) {
      setError("Client ID is missing");
      return;
    }


  try {
    setError("");
    const response = await verifyaADHAROtpSignUP({
      clientId: clientID,
      otp: currentOtp
    });

    if (response.status.code === 200) {
      showSuccessToast(response.status.message || response.message || "Aadhaar verified successfully");
      setError("");
      const aadharData = response?.data?.data || response.data ||null;

      // ✅ Save Aadhaar full response ONLY after OTP success
setSignatoryData(prev => ({
  ...prev,
  name: aadharData?.full_name || prev.name,
  dob: aadharData?.dob || prev.dob,
  gender: aadharData?.gender || prev.gender,
  landmarkAddress: aadharData?.address?.landmark || prev.landmarkAddress,
  address: aadharData?.address
    ? `${aadharData.address.house}, ${aadharData.address.street}, ${aadharData.address.vtc}, ${aadharData.address.subdist}, ${aadharData.address.dist}, ${aadharData.address.state}, ${aadharData.address.country}`
    : prev.address,
  aadharNo: aadharData?.aadhaar_number || prev.aadharNo,
  aadhar_response: aadharData
}));

      // ✅ Close modal AFTER storing data
      setTimeout(() => {
        toggleModal();
        onLoadReport(); // refresh UI
      }, 150);

      return;
    } else {
      showErrorToast(response?.data?.message || response.message || "Aadhaar OTP verification failed");
      setError(response?.data?.message || response.message || "Aadhaar OTP verification failed");
    }

  } catch (err) {
    showErrorToast(err.response?.data?.message || "OTP verification failed");
    console.error("OTP Verify Error:", err);
    setError(err.response?.data?.message || "OTP verification failed");
  }
};


  return (
    isModalOpen && (

      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" style={{ zIndex:999999}}>
        <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-1/3">
          <div className="bg-[#130092] text-white text-center py-4 rounded-t-lg">
            <span className="text-xl">{title}</span>
          </div>
          <div className="p-4">
            <PinInput inputRefs={inputRefs} onPinChange={setOtp} onSubmit={handleSubmit} />
            {error && <div className="text-red-500 mt-2 text-center">{error}</div>}
          </div>
          <div className="flex justify-between p-6">
            <button
              type="button"
              className="bg-red-900 shadow-xl shadow-red-600 bg-gradient-to-r from-red-400 to-red-900 text-white text-xl py-0 px-2 rounded-md hover:from-red-900 hover:to-red-400 focus:outline-none"
              onClick={toggleModal}
            >
              Close
            </button>
            <button
              type="button"
              className="text-center text-white hidden bg-blue-900 shadow-xl  shadow-blue-600  bg-gradient-to-r from-blue-400 to-blue-900 font-semibold rounded-md px-2 py-0 text-xl hover:from-blue-900 hover:to-blue-400 border-1"
               onClick={() => handleSubmit()} 
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default DigitalKycAadharSignUp;
